import { render, staticRenderFns } from "./tableBtn.vue?vue&type=template&id=1b78b11f&scoped=true"
import script from "./tableBtn.vue?vue&type=script&lang=js"
export * from "./tableBtn.vue?vue&type=script&lang=js"
import style0 from "./tableBtn.vue?vue&type=style&index=0&id=1b78b11f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78b11f",
  null
  
)

export default component.exports